// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bb2Nj_egGfH3Ck5_wRuF {
  position: fixed;
  right: 14px;
  bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 9999;
  width: min(360px, calc(100vw - 28px));
}

.SLrQYAjLn4Z4kk8WQ9P2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-radius: 10px;
  border: 1px solid transparent;
  padding: 10px 12px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16);
  background: var(--dst-panel-subtle);
  color: var(--dst-text);
  font-size: 0.9rem;
}

.y6dO37xvqzWlsIdGpJnx {
  background: var(--dst-success-bg);
  border-color: var(--dst-success-border);
  color: var(--dst-success-text);
}

.AncIVyUQvqP_vcgbhWrf {
  background: var(--dst-error-bg);
  border-color: var(--dst-error-border);
  color: var(--dst-error-text);
}

.hWNy19j9qtg3RpjmcRl8 {
  background: var(--dst-info-bg);
  border-color: var(--dst-info-border);
  color: var(--dst-info-text);
}

.LI9pCEKvDwHU7k_lJyRI {
  border: none;
  background: transparent;
  color: inherit;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  min-width: 18px;
}

@media (max-width: 768px) {
  .Bb2Nj_egGfH3Ck5_wRuF {
    right: 8px;
    left: 8px;
    bottom: 8px;
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./assets/js/src/components/Toast/ToastViewport.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;EAC3C,mCAAmC;EACnC,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,SAAS;IACT,WAAW;IACX,WAAW;EACb;AACF","sourcesContent":[".viewport {\n  position: fixed;\n  right: 14px;\n  bottom: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  z-index: 9999;\n  width: min(360px, calc(100vw - 28px));\n}\n\n.toast {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  padding: 10px 12px;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16);\n  background: var(--dst-panel-subtle);\n  color: var(--dst-text);\n  font-size: 0.9rem;\n}\n\n.success {\n  background: var(--dst-success-bg);\n  border-color: var(--dst-success-border);\n  color: var(--dst-success-text);\n}\n\n.error {\n  background: var(--dst-error-bg);\n  border-color: var(--dst-error-border);\n  color: var(--dst-error-text);\n}\n\n.info {\n  background: var(--dst-info-bg);\n  border-color: var(--dst-info-border);\n  color: var(--dst-info-text);\n}\n\n.dismiss {\n  border: none;\n  background: transparent;\n  color: inherit;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n  min-width: 18px;\n}\n\n@media (max-width: 768px) {\n  .viewport {\n    right: 8px;\n    left: 8px;\n    bottom: 8px;\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewport": `Bb2Nj_egGfH3Ck5_wRuF`,
	"toast": `SLrQYAjLn4Z4kk8WQ9P2`,
	"success": `y6dO37xvqzWlsIdGpJnx`,
	"error": `AncIVyUQvqP_vcgbhWrf`,
	"info": `hWNy19j9qtg3RpjmcRl8`,
	"dismiss": `LI9pCEKvDwHU7k_lJyRI`
};
export default ___CSS_LOADER_EXPORT___;
